import React, { useMemo } from 'react';
import { createDropdownList } from 'components/views/atoms/DropdownList';
import styled from '@emotion/styled';
import { fontFamily } from 'components/views/default';

const Item = styled.div({
    fontSize: '14px',
    fontFamily,
    padding: '10px',
});

type SubScreenLayoutWithNumber = {
    id: number;
}

const SubScreenLayoutDropdownList = createDropdownList<SubScreenLayoutWithNumber>(item => <Item>{`Sub Display ${item.id}`}</Item>);

const Title = styled.div({
    color: 'white',
    fontSize: '14px',
    fontFamily,
    padding: '10px',
    userSelect: 'none',
    ':hover': {
        color: '#23527c',
    },
});

const SubScreenLayoutName = styled.span({
    fontSize: '20px',
    marginLeft: '0.3em',
});

export type SubScreenLayoutSelectorProps = {
    numberOfScreens: number;
    selected: number | null;
    onSelect: (selected: number) => void;
};

export const SubScreenLayoutSelector = (props: SubScreenLayoutSelectorProps) => {
    const { numberOfScreens, selected, onSelect } = props;

    const values = useMemo(() => {
        return numberOfScreens > 0 ? [...Array(numberOfScreens)].map((_, i) => ({ id: i + 1 })) : [];
    }, [numberOfScreens]);

    return (
        <React.Fragment>
            <SubScreenLayoutDropdownList values={values} direction={'DOWN'} onSelect={layout => onSelect(layout.id)}>
                {
                    selected != null
                        ? <Title>
                            <span>Sub Display:</span>
                            <SubScreenLayoutName>{selected}</SubScreenLayoutName>
                        </Title>
                        :
                        values.length > 0
                            ? <Title>
                                <SubScreenLayoutName>please select layout</SubScreenLayoutName>
                            </Title>
                            : <Title>
                                <SubScreenLayoutName>no layout</SubScreenLayoutName>
                            </Title>
                }
            </SubScreenLayoutDropdownList>
        </React.Fragment>
    );
};
